import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/bb74bfb/node_modules/@undataforum/gatsby-theme-base/src/components/mdx-page.js";
import MdxLayout from '../../src/components/mdx-layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = MdxLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <p>{`This section provides a space to explore challenges and solutions available to
National Statistical Offices to be agile and innovative in adapting their data
production methods and processes and ensure continuity of major official
statistical programmes.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      